import React from 'react';
import { Link } from 'react-router-dom';

import { BackButton } from './BackButton';

const BackButtonLayout = ({
  children,
  to,
  onBackClick,
}: {
  children?: React.ReactNode;
  to?: string;
  onBackClick?: () => void;
}): JSX.Element => (
  <div style={{ display: 'flex', maxWidth: 1280, marginBottom: 40 }}>
    <div style={{ marginRight: 16, marginLeft: 16 }}>
      {to ? (
        <Link to={to}>
          <BackButton />
        </Link>
      ) : (
        <BackButton onClick={onBackClick} />
      )}
    </div>
    <div style={{ flex: '1 1 auto', minWidth: 0 }}>{children}</div>
  </div>
);

export default BackButtonLayout;
